import { Component, OnDestroy, OnInit } from '@angular/core';
import { CorePageBaseComponent } from '../core-page-base.component';
import { Subscription } from 'rxjs';
import { WorkflowPageNavigationService } from '../../../../service/workflow-page-navigation/workflow-page-navigation.service';
import { WorkflowWidgetEventServiceService } from '../../../../widget/workflow-widget-event.service';
import { AppConfigService, TokenService } from '@cudirect/shared-ui-library';
import { CardInstance } from '@workflow/class/card.service';

/**
 * A component to render the page header including title and subtitle
 */
@Component({
  selector: 'cu-dynamic-page-header',
  templateUrl: './page-header.component.html'
})
export class PageHeaderComponent extends CorePageBaseComponent implements OnInit, OnDestroy {
  constructor(
    public workflowPageNavigationService: WorkflowPageNavigationService,
    public widgetEventService: WorkflowWidgetEventServiceService,
    private readonly tokenService: TokenService,
    private readonly configService: AppConfigService
  ) {
    super(workflowPageNavigationService, widgetEventService);
  }

  public showResumeBanner = false;
  public get showYouthNoteBanner(): boolean {
    return this.page.id.includes('oao-application-fields-youth') && this.youthCard?.visible;
  }
  public subscriptions = new Subscription();
  public loggedIn = false;
  public get showRemove(): boolean {
    return this.page.showRemove && (!this.page.config.removePosition || this.page.config.removePosition === 'top');
  }

  private youthCard: CardInstance;

  public ngOnInit(): void {
    // what is this ecp-user-session referencing?
    // It's the user's token from login widget -Sloan

    let user;
    if (this.configService.settings.adminPortalTokenStorageType === 'sessionStorage') {
      user = sessionStorage.getItem('ecp-user-session');
    } else {
      user = localStorage.getItem('ecp-user-session');
    }
    if (user) {
      const parsedUser = this.tokenService.decodeToken(user);
      const expiry = this.tokenService.tokenExpiryHelper(parsedUser.exp);
      if (expiry > 0) {
        this.loggedIn = true;
      }
    }

    let showBanner = false;
    if (
      this.page.id.includes('ola-econsent-splash-screen') ||
      this.page.id.includes('econsent-splash-screen') ||
      this.page.id.includes('ola-consumer-loan-type') ||
      this.page.id.includes('ola-eligibility') ||
      this.page.id.includes('oao-membership') ||
      this.page.id.includes('oao-eligibility')
    ) {
      const cookie = this.getCookie('arcDXReturningUser');
      if (cookie) {
        showBanner = true;
      }
    } else {
      this.showResumeBanner = false;
    }
    this.showResumeBanner = showBanner;
    if (this.page.id.includes('oao-application-fields-youth'))
      this.youthCard = this.page.cards.find((card) => card.id.includes('oao-primary-applicant-info-youth'));
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  /**
   * get parsed title
   */
  public get pageTitle(): string {
    return this.page.customTitleOrDefault;
  }

  public get pagesubTitle(): string {
    return this.page.customSubtitleOrDefault;
  }

  public getCookie(name: string) {
    const ca: Array<string> = document.cookie.split(';');
    const caLen: number = ca.length;
    const cookieName = `${name}=`;
    let c: string;

    for (let i = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) === 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }
}
